

export const all_routes = {
  // home routes
  homeTwo: "/index",
  // homeOne: "/index",
  // homeThree: "/index-3",
  // homeFour: "/index-4",

  // auth routes
  register: "/authentication/register",
  login: "/authentication/login",
  forgotPassword: "/authentication/forgot-password",
  resetPassword: "/authentication/reset-password",

  // pages routes
  aboutUs: "/pages/aboutUs",
  pricing: "/pages/pricing",
  faq: "/pages/faq",
  gallery: "/pages/gallery",
  invoice: "/pages/invoice-details",
  ourTeam: "/pages/our-team",
  testimonial: "/pages/testimonial",
  termsConditions: "/pages/terms-condition",
  privacyPolicy: "/pages/privacy-policy",
  maintenance: "/pages/maintenance",
  comingSoon: "/pages/coming-soon",
  error404: "/pages/error-404",
  error500: "/pages/error-500",
  contactUs: "/contact-us",

  // booking routes
  booking: "/pages/booking",
  bookingAddon: "/pages/booking-addon",
  bookingCheckout: "/pages/booking-checkout",
  bookingDetail: "/pages/booking-detail",
  bookingPayment: "/pages/booking-payment",
  bookingSuccess: "/pages/booking-success",
  invoiceDetails: "/pages/invoice-details",
  // bookingCalendar: "/pages/booking-calendar",

  // user routes
  userBookingComplete: "/user/user-booking-complete",
  userBookingInprogress: "/user/user-booking-inprogress",
  userBookings: "/user/user-bookings",
  userMessages: "/user/user-messages",
  userDashboard: "/user/user-dashboard",
  userWishlist: "/user/user-wishlist",
  userPayment: "/user/user-payment",
  userSecurity: "/user/user-security",
  preference: "/user/user-preferences",
  notification: "/user/user-notifications",
  userIntegration: "/user/user-integration",
  userWallet: "/user/user-wallet",
  userBookingCancelled: "/user/user-booking-cancelled",
  userBookingUpcoming: "/user/user-booking-upcoming",
  BookingCompleteCalendar: "/user/booking-complete-calendar",
  BookingCancelledCalendar: "/user/booking-cancelled-calendar",
  BookingInprogressCalendar: "/user/booking-inprogress-calendar",
  BookingUpcomingCalendar: "/user/booking-upcoming-calendar",
  BookingCalendar: "/user/bookings-calendar",


  // blog routes
  blogList: "/blog/blog-list",
  blogGrid: "/blog/blog-grid",
  blogDetails: "/blog/blog-details",

  // listing routes
  listingGrid: "/listings/cars",
  listingGridOld: "/listings/listing-grid",
  listingList: "/listings/listing-list",
  listingDetailsNew: "/listings/listing-details",
  listingDetails: "/listings/car/",
  listingMap: "/listings/listing-map",
  addListing: "/listings/add-listing",

  //admin
  adminlogin: "/admin/login",
  adminForgotPassword: "/admin/forgot-password",
  adminOtp: "/admin/otp",
  adminResetPassword: "/admin/reset-password",
  adminDashboard: "/admin/admin-index",
  adminReservationsList: "/admin/reservations",
  adminQuotationsList: "/admin/quotations",
  adminEnquiriesList: "/admin/enquiries",
  adminCustomerList: "/admin/customers",
  adminCustomersCompaniesList: "/admin/customers-companies",
  adminDriversList: "/admin/drivers",
  adminLocationsList:"/admin/locations",
  adminCarsList: "/admin/cars",
  adminBrandsList: "/admin/brands",
  adminTypesList: "/admin/types",
  adminModelsList: "/admin/models",
  adminTransmissionsList: "/admin/transmissions",
  adminFuelList: "/admin/fuel",
  adminColorList: "/admin/color",
  adminSteeringList: "/admin/steering",
  adminSeatsList: "/admin/seats",
  adminCylindersList: "/admin/cylinders",
  adminDoorsList: "/admin/doors",
  adminFeaturesList: "/admin/features",
  adminSafetyFeaturesList: "/admin/safety-features",
  adminCalender:"/admin/calender",
  adminExtraServicesList:"/admin/extra-services",
  adminCarPackagesList:"/admin/car-packages",
  adminPricingList:"/admin/pricing",
  adminInspectionsList:"/admin/inspections",
  adminMaintenanceList:"/admin/maintenance",
  adminReviewsList:"/admin/reviews",
  adminInvoicesList:"/admin/invoices",
  adminAddReservations:"/admin/add-reservation",
  adminEditReservations:"/admin/edit-reservation",
  adminPaymentsList: "/admin/payments",
  adminCouponsList: "/admin/coupons",
  adminNewslettersList: "/admin/newsletters",
  adminPagesList: "/admin/pages",
  adminMenuManagementList: "/admin/menu-management",
  adminBlogsList: "/admin/blogs",
  adminBlogCategoriesList: "/admin/blog-categories",
  adminBlogCommentsList: "/admin/blog-comments",
  adminBlogTagsList: "/admin/blog-tags",
  adminCountriesList: "/admin/countries",
  adminStateList: "/admin/state",
  adminCityList: "/admin/city",
  adminTestimonialsList: "/admin/testimonials",
  adminFaqList: "/admin/faq",
  adminFaqCategoryList: "/admin/faq-category",
  adminContactMessagesList: "/admin/contact-messages",
  adminAnnouncementsList: "/admin/announcements",
  adminTicketsList: "/admin/tickets",
  adminUsersList: "/admin/users",
  adminRolesPermissionsList: "/admin/roles-permissions",
  adminPermissionsList: "/admin/permissions",
  adminIncomeReportList: "/admin/income-report",
  adminEarningsReportList: "/admin/earnings-report",
  adminRentalReportList: "/admin/rental-report",
  addQuotation: "/admin/add-quotations",
  editQuotation: "/admin/edit-quotations",
  quotationDetails: "/admin/quotation-details",
  addCar: "/admin/add-car",
  editCar: "/admin/edit-car",
  adminEditMenu: "/admin/edit-menu",
  adminAddBlog: "/admin/add-blog",
  adminEditBlog: "/admin/edit-blog",
  adminAddPages: "/admin/add-pages",
  adminEditPages: "/admin/edit-pages",
  carDetails: "/admin/car-details",
  companyDetails: "/admin/company-details",
  customerDetails: "/admin/customer-details",
  ticketDetails: "/admin/ticket-details",
  adminblogDetails: "/admin/blog-details",
  reservationDetails: "/admin/reservation-details",
  admininvoiceDetails: "/admin/invoice-details",
  adminChat: "/admin/chat",
  adminAddInvoice: "/admin/add-invoice",
  adminEditInvoice: "/admin/edit-invoice",
  adminTrackingMap: "/admin/tracking",
  


  //UI Pages

  alerts: "/admin/ui-alerts",
  accordion: "/admin/ui-accordion",
  avatar: "/admin/ui-avatar",
  badges: "/admin/ui-badges",
  borders: "/admin/ui-borders",
  buttons: "/admin/ui-buttons",
  buttonsgroup: "/admin/ui-buttons-group",
  breadcrumb: "/admin/ui-breadcrumb",
  cards: "/admin/ui-cards",
  dropdowns: "/admin/ui-dropdowns",
  colors: "/admin/ui-colors",
  carousel: "/admin/ui-carousel",
  navtabs: "/admin/ui-nav-tabs",
  grid: "/admin/ui-grid",
  images: "/admin/ui-images",
  lightbox: "/admin/ui-lightbox",
  media: "/admin/ui-media",
  modals: "/admin/ui-modals",
  offcanvas: "/admin/ui-offcanvas",
  pagination: "/admin/ui-pagination",
  typography: "/admin/ui-typography",
  tooltip: "/admin/ui-tooltips",
  draganddrop: "/admin/ui-drag-drop",
  clipboard: "/admin/ui-clipboard",
  popover: "/admin/ui-popovers",
  tablebasic: "/admin/tables-basic",
  datatable: "/admin/data-tables",
  basicinput: "/admin/form-basic-inputs",
  checkboxradio: "/admin/form-checkbox-radios",
  inputgroup: "/admin/form-input-groups",
  gridgutters: "/admin/form-grid-gutters",
  formselect: "/admin/form-select",
  fileupload: "/admin/form-fileupload",
  formmask: "/admin/form-mask",
  formhorizontal: "/admin/form-horizontal",
  formvertical: "/admin/form-vertical",
  floatinglabel: "/admin/form-floating-labels",
  formvalidation: "/admin/form-validation",
  select2: "/admin/form-select2",

  toasts: "/admin/ui-toasts",
  video: "/admin/ui-video",
  sweetalerts: "/admin/ui-sweetalerts",
  spinner: "/admin/ui-spinner",
  progress: "/admin/ui-progress",
  placeholder: "/admin/ui-placeholders",
  rating: "/admin/ui-rating",
  texteditor: "/admin/ui-text-editor",
  counter: "/admin/ui-counter",
  scrollbar: "/admin/ui-scrollbar",
  stickynote: "/admin/ui-stickynote",
  timeline: "/admin/ui-timeline",
  apexchart: "/admin/chart-apex",
  chartjs: "/admin/chart-js",
  rangeslider: "/admin/ui-rangeslider",
  fontawesome: "/admin/icon-fontawesome",
  // feathericon: "/admin/icon-feather",
  ionicicons: "/admin/icon-ionic",
  materialicons: "/admin/icon-material",
  pe7icons: "/admin/icon-pe7",
  simpleline: "/admin/icon-simpleline",
  themifyicons: "/admin/icon-themify",
  iconweather: "/admin/icon-weather",
  typicons: "/admin/icon-typicon",
  flagicons: "/admin/icon-flag",
  ribbon: "/admin/ui-ribbon",

  chat: "/admin/chat",
  Sortable: "/admin/sortable",
  SwiperJs: "/admin/swiper-js",
  FormPicker: "/admin/form-picker",
  Leaflets: "/admin/leaflet",
  remixIcon: "/admin/remix-icon",
  BootstrapIcon: "/admin/bootstrap-icon",
  TablerIcon: "/admin/tabler-icon",
  wizard: "/admin/form-wizard",


  //admin Settings
  profileSettings: "/admin/account-settings/profile-setting",
  trackerSetting: "/admin/account-settings/tracker-setting",
  integrationsSettings: "/admin/account-settings/integrations-settings",
  notificationsSetting: "/admin/account-settings/notifications-setting",
  securitySetting: "/admin/account-settings/security-setting",
  companySetting: "/admin/website-settings/company-setting",
  localizationSetting: "/admin/website-settings/localization-setting",
  prefixes: "/admin/website-settings/prefixes",
  seoSetup: "/admin/website-settings/seo-setup",
  languageSetting: "/admin/website-settings/language-setting",
  language2Setting: "/admin/website-settings/language-setting2",
  maintenanceMode: "/admin/website-settings/maintenance-mode",
  loginSetting: "/admin/website-settings/login-setting",
  aiConfiguration: "/admin/website-settings/ai-configuration",
  pluginManagers: "/admin/website-settings/plugin-managers",
  rentalSetting: "/admin/rental-settings/rental-setting",
  insuranceSetting: "/admin/rental-settings/insurance-setting",
  invoiceSetting: "/admin/app-settings/invoice-setting",
  invoiceTemplate: "/admin/app-settings/invoice-template",
  signaturesSetting: "/admin/app-settings/signatures-setting",
  customFields: "/admin/app-settings/custom-fields",
  emailSetting: "/admin/system-settings/email-setting",
  emailTemplates: "/admin/system-settings/email-templates",
  smsGateways: "/admin/system-settings/sms-gateways",
  gdprCookies: "/admin/system-settings/gdpr-cookies",
  paymentMethods: "/admin/finance-settings/payment-methods",
  bankAccounts: "/admin/finance-settings/bank-accounts",
  taxRates: "/admin/finance-settings/tax-rates",
  currencies: "/admin/finance-settings/currencies",
  sitemap: "/admin/other-settings/sitemap",
  clearCache: "/admin/other-settings/clear-cache",
  storage: "/admin/other-settings/storage",
  cronjob: "/admin/other-settings/cronjob",
  systemBackup: "/admin/other-settings/system-backup",
  databaseBackup: "/admin/other-settings/database-backup",
  systemUpdate: "/admin/other-settings/insurance",
};
